import React from 'react';
import { useTranslation } from 'next-i18next';
import { getTreatedTeeth } from './DentalTreatments.helpers';
import * as S from './DentalTreatments.styles';
const DentalTreatments = ({
  data = []
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(S.Root, null, data.map(dentalTreatment => {
    const {
      permanent,
      primary
    } = getTreatedTeeth(dentalTreatment.toothPositions);
    const permanentTeethTitle = permanent.length > 0 ? `${t('common.tooth')} ${permanent.join()}` : '';
    const primaryTeethTitle = primary.length > 0 ? `${t('common.baby_tooth')} ${primary.join()}` : '';
    const title = permanentTeethTitle && primaryTeethTitle ? `${permanentTeethTitle}; ${primaryTeethTitle}` : permanentTeethTitle || primaryTeethTitle || null;
    return /*#__PURE__*/React.createElement(S.Record, {
      key: dentalTreatment.referenceId
    }, title && /*#__PURE__*/React.createElement(S.Label, null, title), /*#__PURE__*/React.createElement(S.Value, null, dentalTreatment.contentfulKeys.map(key => t(`b2c.dentaltreatments.${key}`)).join('; ')));
  }));
};
export default DentalTreatments;